'use strict';

angular.module('atex.dam').controller('DamImplementScheduleModalController', ['$scope', '$modal', '$timeout', '$rootScope', '$q', '$http', 'AuthenticationService', 'ContentService', 'DamTemplateService', 'DamService', 'configuration','DamConfigurationService', '$translate', 'DamStatusService', 'DamMarkAsService','DamNotificationService', 'UIConfigurationService', 'DamSchedulingService',
  function($scope, $modal, $timeout, $rootScope, $q, $http, AuthenticationService, ContentService, DamTemplateService, DamService, configuration, DamConfigurationService, $translate, DamStatusService, DamMarkAsService, DamNotificationService, UIConfigurationService, DamSchedulingService) {

    $scope.planningItem = $scope.model.planningItem;
    $scope.timeZone = undefined;
    $scope.loaded = false;
    $scope.showSpinner = true;
    $scope.isValid = false;
    $scope.content = atex.Content();
    $scope.schedules = [];
    $translate(['__GENERIC_ERROR_MSG__', '__OPERATION_COMPLETED_SUCCESSFULLY__', '__PUBLISHING_SCHEDULE_CREATED__', '__PUBLISHING_SCHEDULE_INSTANCE_CREATED__' ]).then(function (translations) {
      $scope.message = {};
      $scope.message.error = translations.__GENERIC_ERROR_MSG__;
      $scope.message.success = translations.__OPERATION_COMPLETED_SUCCESSFULLY__;
      $scope.message.instanceCreated = translations.__PUBLISHING_SCHEDULE_INSTANCE_CREATED__;
    });
    $scope.instance = {};

    $scope.content.data.aspects = {
      "contentData": {
        "data": {
          "_type": "atex.dam.standard.PublishingSchedule"
        }
      }
    };

    $scope.datePickerTemplate = {
      "id": "dam.pubdate.picker",
      "dataBindings": [
        {
          "name" : "publicationDate",
          "widget": "pDateTimePicker",
          "config": {
            "dtConfig": {
              "format": "DD/MM/YYYY"
            },
            "editable" : true
          },
          "domainObjects": {
            "data": "contentData/publicationDate"
          }
        }
      ]
    };

    $scope.changeEndCallbackPubDate = function (data) {
      $scope.content.data.aspects.contentData.data.publicationDate = data.aspects.contentData.data.publicationDate;
      $scope.checkIfValid();
      $scope.dirty = true;
      if(!$scope.$$phase) {
        $scope.$digest();
      }
      return;
    };

    $scope.checkIfValid = function () {
      if ($scope.content.data.aspects.contentData.data.publicationDate !== undefined && $scope.instance.data !== undefined) {
        $scope.isValid = true;
      } else {
        $scope.isValid = false;
      }
    };

    if ($scope.planningItem && $scope.planningItem.day) {
      $scope.content.data.aspects.contentData.data.publicationDate = $scope.planningItem.day.utc().valueOf();
      $scope.changeEndCallbackPubDate($scope.content.data);
    }

    DamSchedulingService.getPublishingSchedulesForPublication($scope.planningItem.getPrintPublication()).then(function (response) {
      $scope.schedules = response || [];

      if ($scope.schedules && $scope.schedules.length === 1) {
        $scope.instance.data = $scope.schedules[0];
        $scope.updateSchedule();
      }

      $scope.loaded = true;


    }).then(null, function (error) {
      var message =  $scope.message.error + " (" + error.cause + ")";
      DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
    });

    $scope.hideSpinner = function () {
      $scope.showSpinner = false;
    };

    function submit(cleanData) {
      processSchedule(cleanData).then(function (result) {
        $scope.$parent.doOk(result);
        $scope.hideSpinner();
      });
    }

    $scope.doSave = function () {
      if (!$scope.showSpinner) {
        $scope.showSpinner = true;
        $scope.instance.pubDate = $scope.content.data.aspects.contentData.data.publicationDate;
        submit($scope.instance);
      }
    };

    $scope.updateSchedule = function() {
       if ($scope.instance.data) {
         $scope.timeZone = atex.onecms.ObjectUtils.getByPath($scope.instance, "data/aspects/contentData/data/timeZone");
       } else {
         $scope.timeZone = undefined;
       }
       $scope.checkIfValid();
    };

    $scope.isOkEnabled = function () {
      return !$scope.showSpinner && $scope.isValid && $scope.dirty;
    };

    function processSchedule(result) {
      var deferred = $q.defer();
      $scope.showSpinner = true;
      DamService.implementSchedule(result.data.id, result.pubDate).then(function (response) {
        deferred.resolve(response);
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $scope.message.instanceCreated
        }),false);
        $scope.hideSpinner();
      }).then(null, function (error) {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'error',
          message: error.data.message
        }),true);
        deferred.reject(error);
        $scope.hideSpinner();
      });
      return deferred.promise;
    }

}]);